import { useState } from 'react';

import { useTheme, Grid, usePreventWindowScroll } from '@simplywallst/ui-core';

import ActionSheet, { Sheet, Background } from '@/components/ActionSheet';

import { usePortfolio } from '@/hooks/portfolio/usePortfolio';
import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

import { AddHoldingsDesktop } from '../AddHoldings';
import { EditHoldings } from '../EditHoldings';
import type { ManualPortfolioState } from '../CreateManualPortfolio';

import type { PortfolioToUpdate } from '../../context/ManualPortfolioContext';

interface Props {
  initialData?: PortfolioToUpdate;
  portfolioId: Portfolio['id'] | null;
  setPortfolioId: (id: string) => void;
  onClose: () => void;
  manualPortfolioState: ManualPortfolioState;
  setManualPortfolioState: (state: ManualPortfolioState) => void;
}

export const HoldingsActionSheet = ({
  initialData,
  portfolioId,
  setPortfolioId,
  onClose,
  manualPortfolioState,
  setManualPortfolioState,
}: Props) => {
  const theme = useTheme();
  usePreventWindowScroll();
  const [open, setOpen] = useState(true);

  const { data: portfolio } = usePortfolio({
    id: portfolioId ?? '',
  });

  return (
    <ActionSheet open={open} onClose={() => setOpen(false)} onClosed={onClose}>
      <Background />
      <Sheet>
        <Grid templateRows={`calc(40px + ${theme.safeAreaInsetTop}) auto`}>
          <Grid
            row="2"
            borderTopLeftRadius="x2"
            borderTopRightRadius="x2"
            backgroundColor="noir"
            templateRows="1fr"
          >
            {manualPortfolioState === 'add' ? (
              <AddHoldingsDesktop
                portfolio={portfolio}
                setManualPortfolioState={setManualPortfolioState}
                setPortfolioId={setPortfolioId}
              />
            ) : manualPortfolioState === 'edit' && portfolio ? (
              <EditHoldings
                initialData={initialData}
                onClose={() => setOpen(false)}
                portfolio={portfolio}
                setManualPortfolioState={setManualPortfolioState}
              />
            ) : null}
          </Grid>
        </Grid>
      </Sheet>
    </ActionSheet>
  );
};
